/**
 * Valumize Algorithmic DMV API
 * Batch-run the algorithmic discount-multiple valuation across many holdings of a fund within the context of a specific Bottom-Up fund valuation. Mirrors the single-asset \"fox button\" calculation but scales it across a fund. Generated results are staged for user review and only written back to AssetValuation when the user explicitly accepts each one. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlgorithmicDmvOverwriteMode } from './algorithmic-dmv-overwrite-mode';
import { AlgorithmicDmvExitEnvironment } from './algorithmic-dmv-exit-environment';


export interface AlgorithmicDmvJobInfo { 
    taskInfoId: number;
    fundId: number;
    fundValuationId: number;
    /**
     * kwsoft async task lifecycle status
     */
    status: AlgorithmicDmvJobInfo.StatusEnum;
    started: string;
    finished?: string;
    errorMessage?: string;
    startedBy?: number;
    overwriteMode: AlgorithmicDmvOverwriteMode;
    agentReviewEnabled: boolean;
    /**
     * Expected gross IRR (fraction) the batch ran with
     */
    requiredGrossIrr?: number;
    /**
     * GP quality (LOW/MEDIUM/HIGH) the batch ran with
     */
    gpQuality?: AlgorithmicDmvJobInfo.GpQualityEnum;
    /**
     * Fund\'s 3-letter ISO currency code (e.g. EUR/USD) for labelling figures in the viewer
     */
    fundCurrency?: string;
    /**
     * Accumulated agent cost in USD cents (0 in algorithm-only path)
     */
    costCents: number;
    exitEnvironment?: AlgorithmicDmvExitEnvironment;
    /**
     * Number of results generated (populated when COMPLETED)
     */
    totalResultCount?: number;
    /**
     * Number of results still awaiting user review
     */
    pendingReviewCount?: number;
}
export namespace AlgorithmicDmvJobInfo {
    export type StatusEnum = 'NEW' | 'IN_PROGRESS' | 'COMPLETED' | 'ERROR' | 'TIMEOUT' | 'CANCELLED' | 'CANCELLING';
    export const StatusEnum = {
        New: 'NEW' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Timeout: 'TIMEOUT' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum,
        Cancelling: 'CANCELLING' as StatusEnum
    };
    export type GpQualityEnum = 'LOW' | 'MEDIUM' | 'HIGH';
    export const GpQualityEnum = {
        Low: 'LOW' as GpQualityEnum,
        Medium: 'MEDIUM' as GpQualityEnum,
        High: 'HIGH' as GpQualityEnum
    };
}


